import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {
    setParameterToMap,
       } from 'actions/index.js';

const colors = new Colors();

const MacroOverlay = ({
    parameter,
    isMacroMapping,
    isParameterToMap,
    setParameterToMap
}) => { 
    if (isMacroMapping && parameter) {
        let className = "macro-overlay";
        if (isParameterToMap) {
            className += " parameter-to-map";
        }
        
        if (parameter.hasMacro) {
            className += " mapped";
        }
        
        let style = {
        };
        
        if (parameter.hasMacro) {
            style = {
                backgroundColor: colors.getColorForHash(parameter.hasMacro.id)
                
            };
        }
        
        let text = parameter.hasMacro && parameter.hasMacro.name;
        
        return (
            <div
              onClick={() => setParameterToMap(parameter)}
              className={className}>
              <div className="overlay-main"></div>
              <div className="overlay-detail" style={style}>
                {text}
              </div>
            </div>
        );
    }
    
    return '';
};

const mapStateToProps = (state, props) => {
  return {
      isMacroMapping: state.effects.isMacroMapping,
      isParameterToMap: props.parameter &&
          state.effects.parameterToMap === props.parameter, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroOverlay);
